export const my_listings = {
  page_title: "My Listings",
  tab_active: "Active Listings",
  tab_past: "Past Sales",
  sell_a_part: "Sell a Part",
  empty_active_title: "You haven't listed any parts yet.",
  empty_past_title: "No past sales yet.",
  listed_on: "Listed on {date}",
  sold_on: "Sold on {date}",
  removed_on: "Removed on {date}",
  edit: "Edit",
  open: "Open",
  edit_aria: "Edit listing",
  open_aria: "Open listing",
  status_available: "Available",
  status_pending: "Pending",
  status_sold: "Sold",
  status_removed: "Removed",
};
